import { Injectable } from '@angular/core';
import { WindowWrapper } from './window.injection';

const url = 'https://www.bing.com/api/maps/mapcontrol?callback=__onBingLoaded';

@Injectable()
export class BingMapsService {
    constructor(private window: WindowWrapper) {
        // tslint:disable-next-line: no-string-literal
        this.window['__onBingLoaded'] = {};
    }
    private static promise = null;

    public static load() {
        if (!BingMapsService.promise) {

            BingMapsService.promise = new Promise( resolve => {
                // tslint:disable-next-line: no-string-literal
                window['__onBingLoaded'] = (ev) => {
                    resolve('Bing Maps API loaded');
                };

                const s = document.createElement('script');
                s.src = url;
                s.type = 'text/javascript';
                s.async = true;
                s.defer = true;
                document.getElementsByTagName('head')[0].appendChild(s);
            });
        }

        return BingMapsService.promise;
    }
}
